var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProflieCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8Z",
    fill: "#DEEBFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3977 4.92673L6.62434 9.5334L5.35767 8.18007C5.12434 7.96007 4.75767 7.94673 4.491 8.1334C4.231 8.32673 4.15767 8.66673 4.31767 8.94007L5.81767 11.3801C5.96434 11.6067 6.21767 11.7467 6.50434 11.7467C6.77767 11.7467 7.03767 11.6067 7.18434 11.3801C7.42434 11.0667 12.0043 5.60673 12.0043 5.60673C12.6043 4.9934 11.8777 4.4534 11.3977 4.92007V4.92673Z",
    fill: "#003CE9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProflieCheck);
export default __webpack_public_path__ + "static/media/proflie-check.4adbe1132a4d781a5a884d6d639776e8.svg";
export { ForwardRef as ReactComponent };